import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { commercialConstants } from '../../../../common/commercial-constants';

@Component({
    selector: 'is-general-liability',
    templateUrl: './general-liability.component.html',
    styleUrls: ['./general-liability.component.scss'],
    standalone: false
})
export class GeneralLiabilityComponent implements OnInit {
    @Input() fnolForm: UntypedFormGroup;
    claimantName: UntypedFormControl = new UntypedFormControl('', [Validators.required,
    Validators.pattern(commercialConstants.regexValidators.nameField)]);
    claimantNameLabel = 'Claimant\'s name';
    claimantPhoneNumber: UntypedFormControl = new UntypedFormControl('', [Validators.required,
    Validators.pattern(/^[1-9]\d{2}-\d{3}-\d{4}$/)]);
    estimatedDamages: UntypedFormControl = new UntypedFormControl('', Validators.required);
    generalLiabilityForm: UntypedFormGroup;
    liabilitySubtype: UntypedFormControl = new UntypedFormControl('', Validators.required);
    liabilitySubtypes: string[] = ['ADA Claims', 'Advertising Injury', 'Contingent Liability', 'Coverage Split',
        'Directors and Officers Liability', 'Dram Shop / Liquor Liability', 'E - Commerce', 'Employer Practices Liability',
        'Employers Liability', 'Medical Payments', 'Other', 'Personal Injury', 'Professional Liability'];
    lossType: UntypedFormControl = new UntypedFormControl('', Validators.required);

    constructor(private formBuilder: UntypedFormBuilder) { }
    buildForm(): void {
        // Need to add new regex validations for claims fields
        this.fnolForm.addControl('generalLiability', this.generalLiabilityForm = this.formBuilder.group({
            lossType: this.lossType,
            estimatedDamages: this.estimatedDamages,
            liabilitySubtype: this.liabilitySubtype,
            claimantName: this.claimantName,
            claimantPhoneNumber: this.claimantPhoneNumber
        }));
    }

    ngOnInit(): void {
        this.buildForm();
        this.lossType.valueChanges.subscribe((value) => {
            if (value === 'Bodily Injury') {
                this.claimantNameLabel = 'Injured person\'s name (claimant)';
            } else if (value === 'Property Damage') {
                this.claimantNameLabel = 'Damaged property owner\'s name (claimant)';
            } else {
                this.claimantNameLabel = 'Claimant\'s name';
            }
        });
    }

    // defaults the 2 dropdowns when the lossType value has changed
    resetDependentLossTypeSelectLists(): void {
        this.estimatedDamages.clearValidators();
        this.estimatedDamages.setValue('');
        this.estimatedDamages.markAsUntouched();
        this.estimatedDamages.markAsPristine();
        this.liabilitySubtype.clearValidators();
        this.liabilitySubtype.setValue('');
        this.liabilitySubtype.markAsUntouched();
        this.liabilitySubtype.markAsPristine();
        this.estimatedDamages.setValidators(Validators.required);
        this.liabilitySubtype.setValidators(Validators.required);
    }
}
